import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Base = ({ children }) => {
  return (
    <div
      style={{
        height: `calc(100% - 90px)`,
        overflowY: "auto",
        width: "100%",
      }}
      className="mainContainer"
    >
      {children}
      <Footer />
      <a className="scrolltop" href="#top">
        <i className="icofont-hand-drawn-up"></i>
      </a>
    </div>
  );
};

export default Base;
